import ENDPOINT from "@/api/endpoints";
import { HTTP } from "@/api/http-common";

export function callApiSearchDoKhan(payload) {
  return HTTP({
    url: ENDPOINT.DO_KHAN.SEARCH,
    method: "GET",
    params: payload,
  });
}
